export default {
  nav: {
    home: "Casa",
    about: "Di",
    contact: "Contatto"
  },
  languageSwitcher: {
    selectLanguage: "Seleziona lingua",
  },
  userMenu: {
    profile: "Profilo",
    settings: "Impostazioni",
    logout: "Disconnettersi"
  },
  home: {
    header: "Benvenuti al tutorial Vue 3 I18n!",
    created_by: "Questo tutorial è stato portato a voi da Lokalise.",
    welcome: "Siamo lieti di averti qui. Esplora le funzionalità di internazionalizzazione con Vue 3 e I18n."
  },
  about: {
    header: "Su di noi"
  },
  login: {
    header: "Accedi al tuo account",
    subheader: "Inserisci le tue credenziali per accedere al tuo account.",
    email: "Indirizzo e-mail",
    password: "Parola d'ordine",
    remember_me: "Ricordati di me",
    forgot_password: "Hai dimenticato la password?",
    login_button: "Accesso",
    login_button_loading: "Accesso in corso...",
    login_error: "Impossibile accedere. Controlla le credenziali e riprova.",
    footer_sign_up_message: "Non hai un account?",
    footer_sign_up_link: "Iscriviti ora"
  },
  actions: {
    save: "Salvare",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    update: "Aggiornare",
    ok: "OK"
  }
}
